import { render } from "./SettingPanel.vue?vue&type=template&id=50f44049&scoped=true&ts=true"
import script from "./SettingPanel.vue?vue&type=script&lang=ts"
export * from "./SettingPanel.vue?vue&type=script&lang=ts"

import "./SettingPanel.vue?vue&type=style&index=0&id=50f44049&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f44049"]])

export default __exports__